/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: store.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:58
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import { createStore } from 'vuex'
import modules from './modules'
import { SupportedLanguages } from "@/i18n";

const store = createStore({
    modules,
    // Enable strict mode in development to get a warning
    // when mutating state outside of a mutation.
    // https://vuex.vuejs.org/guide/strict.html
    strict: process.env.NODE_ENV !== 'production',
    state: {
        currentLanguageValue: 0,
        selectedIdpProvider: null,
    },

    getters: {
        currentProvider(state) {
            return state.selectedIdpProvider;
        },

        currentLanguage(state) {
            return SupportedLanguages.find(lang => lang.value === state.currentLanguageValue)
                || SupportedLanguages[0]
        },

        currentLanguageFlag(state, getters) {
            return getters.currentLanguage.flag
        },

        currentLanguageTitle(state, getters) {
            return getters.currentLanguage.title
        }
    },

    mutations: {
        SET_LANGUAGE(state, langValue) {
            state.currentLanguageValue = langValue
        },

        SET_SELECTED_IDP_PROVIDER(state, provider) {
            state.selectedIdpProvider = provider
        }
    },

    actions: {
        setLanguage({ commit }, langValue) {
            commit('SET_LANGUAGE', langValue)
        },

        setSelectedIdpProvider({ commit }, provider) {
            commit('SET_SELECTED_IDP_PROVIDER', provider)
        },

        setInitialLanguage({ commit }, langValue) {
            commit('SET_LANGUAGE', langValue)
        }
    }
})

export default store